<template>
  <b-modal
    id="delete-reward-modal"
    title="Delete reward"
  >
    <h4 class="text-center">
      Are you sure you want to delete {{ name }}?
    </h4>
    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            variant="danger"
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="deleteHandler"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner, BRow, BCol,
  },
  props: {
    reward: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const deleteHandler = async () => {
      submitting.value = true
      await ctx.root.$store.dispatch('rewards/deleteReward', props.reward.id)
      await new Promise(resolve => {
        setTimeout(async () => {
          try {
            ctx.emit('deleted')
            ctx.root.$bvModal.hide('delete-reward-modal')
          } finally {
            submitting.value = false
            resolve()
          }
        }, 1500)
      })
    }
    const name = computed(() => props.reward?.name?.en)
    return {
      name,
      submitting,
      deleteHandler,
    }
  },
}
</script>

<style>

</style>
